module.exports = __webpack_public_path__ + "img/calc-5.a769ba3e.png";